<template>
    <div
        class="tw-h-[80px]x tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-flex tw-gap-4 tw-p-4">

            <div v-if="!props.company.logo" class="tw-w-[60px] tw-h-[60px]">
                <icon icon="streamline-kameleon-color:apartment-2-duo" class="tw-text-6xl" />
            </div>
            <div v-else class="tw-min-w-[60px] tw-max-w-[60px] tw-min-h-[60px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-p-1 tw-border tw-border-gray-200 tw-overflow-hidden">
                <img :src="props.company.logo" class="tw-block tw-w-full tw-h-full tw-object-contain tw-rounded-lg" />
            </div>

        <div class="tw-flex tw-flex-col tw-justify-center tw-gap-1 tw-flex-1 tw-truncate">
            <h1 class="tw-text-primary-950 tw-text-lg  tw-font-semibold tw-truncate">{{ props.company.name }}</h1>
            <h2 class="tw-text-primary-950 tw-text-sm tw-font-semibold tw-capitalize">{{ $user.role }}</h2>
        </div>


            <div v-if="!loading" class="tw-flex tw-items-center tw-justify-center">
                <button @click="onEditClick">
                    <icon icon="solar:pen-linear" class="tw-text-gray-400 tw-text-2xl" />
                </button>
            </div>

            <div v-else class="tw-flex tw-items-center tw-justify-center">
                <icon icon="mingcute:loading-fill" class="tw-text-gray-400 tw-text-2xl tw-animate-spin" />
            </div>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import meApi from '@/api/me';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = useRouter();
const authStore = useAuthStore();
const loading = ref(false);

const props = defineProps({
    company: {
        type: Object,
        required: true
    }
})

const onEditClick = async () => {
    loading.value = true;
    await meApi.actAsCompany(props.company.id)
    .then(response => {
        if (response.data.code == 'SUCCESS') {
            authStore.setCompany(response.data.data.acting_company);
            authStore.setIsLoggedIn(true);
            router.push({ name: 'pages.company.dashboard' });
        }
    })
    .catch(error => {
        console.log(error);
    })
    loading.value = false;
}


</script>

<style scoped></style>